import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=0b8544ce&scoped=true&"
import script from "./Solutions.vue?vue&type=script&lang=js&"
export * from "./Solutions.vue?vue&type=script&lang=js&"
import style0 from "./Solutions.vue?vue&type=style&index=0&id=0b8544ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8544ce",
  null
  
)

export default component.exports